import { FC, memo } from 'react';
import TableCell from '@material-ui/core/TableCell';
import Status from '~/ui/components/common/Status';

import { IClient } from '~/services/api/client/types';
import getCurrentClientTeams from '../../reusable/Table/utils';
import { IClientsFilters } from '~/store/client/types';

interface IProps {
  item: IClient;
  filters: Partial<IClientsFilters>;
}

const MyClientsTableBody: FC<IProps> = ({ item, filters }) => {
  const { archived, active } = getCurrentClientTeams(item.teams, {
    teams: filters.teams,
    status: filters.status,
  });

  return (
    <>
      <TableCell>
        {active.map(team => (
          <div key={team.team.id}>{team.team.name}</div>
        ))}
        {archived.map(team => (
          <div key={team.team.id}>{team.team.name}</div>
        ))}
      </TableCell>
      <TableCell>
        {active.map(team => (
          <Status key={team.team.id} isArchived={team.isArchived} />
        ))}
        {archived.map(team => (
          <Status key={team.team.id} isArchived={team.isArchived} />
        ))}
      </TableCell>
    </>
  );
};

export default memo(MyClientsTableBody);
